import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { AccountStatementRepository } from "../Repositories/account-statement.repository";
import { AccountStatementFilter, AccountStatementReportFilter } from "../Types/Interfaces/account-statement-filter.interface";
import { AccountStatement, AccountStatementEmail } from "../Types/Interfaces/account-statement.interface";

@Injectable({
  providedIn: "root",
})
export class AccountStatementService {
  constructor(private accountStatementRepository: AccountStatementRepository, private fileHandlerService: FileHandlerService) {}

  public getStatementsDropdown(): Observable<DropdownOption[]> {
    return this.accountStatementRepository.getStatementsDropdown();
  }

  public getAccountStatement(accountStatementFilter: AccountStatementFilter): Observable<AccountStatement[]> {
    return this.accountStatementRepository.getAccountStatement(accountStatementFilter);
  }

  public getAccountStatementReport(accountStatementReportFilter: AccountStatementReportFilter): void {
    this.accountStatementRepository
      .getAccountStatementReport(accountStatementReportFilter)
      .pipe(first())
      .subscribe((report) => {
        this.fileHandlerService.openPdfInNewTab(report);
      });
  }

  public sendEmailNotification(request: AccountStatementEmail): Observable<ShareMessageResponse> {
    return this.accountStatementRepository.sendEmailNotification(request);
  }
}
